// extracted by mini-css-extract-plugin
export default {"slots":"Slots_slots__SgK-7","reward":"Slots_reward__qppxb","item":"Slots_item__khFGp","required":"Slots_required__OnGPC","recommended":"Slots_recommended__bIWdl"};